import React from 'react';
import './Chapters.scss';

function Chapter3() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__title">Nature Meets Technology</p>
        <p className="chapter__paragraph">
          David Will has spent his career trying to change those numbers.
        </p>
        <p className="chapter__paragraph">
          Will is the Head of Innovation at Island Conservation, an organization that protects
          endangered species by removing invasive species. Early on, he spent a year and a half on
          California’s San Nicholas Island tracking invasive species.
        </p>
        <p className="chapter__paragraph">
          “I can tell you, one of the most depressing things is waking up every day and hoping you
          don't find a footprint of an animal in the sand,” Will says, “because if you find it, it
          means you've got another couple of months trying to chase it.”
        </p>
        <p className="chapter__paragraph">
          Will’s mission is to implement technological solutions to make curbing invasive species
          more time- and cost-efficient. For years, Island Conservation had been working with the
          community of Robinson Crusoe to remove invasive species when the organization spearheaded
          an ambitious project of placing 70 wildlife cameras across the island to track the
          progress of their removal efforts.
        </p>
      </section>
    </>
  );
}

export default Chapter3;
